<template>
  <div id="CodeEditBtn">
    <el-button icon="el-icon-edit" @click="showEditText"></el-button>
    <el-dialog :title="mTitle" :visible.sync="mVisible" @open="openDlg" :modal-append-to-body="false" :close-on-click-modal="false" append-to-body>
      <codemirror ref="myCm"
                  v-model="vCode"
                  :options="mOptions"
                  @changes="changes">
      </codemirror>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="mCancel">{{$t('common.cancel')}}</el-button>
        <el-button type="primary" size="small" @click="mConfirm">{{$t('common.confirm')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import 'codemirror/theme/blackboard.css'
require('codemirror/mode/javascript/javascript.js')
require('codemirror/mode/sql/sql.js')
export default {
  name: 'CodeEditBtn',
  props: ['mTitle', 'mCode', 'mObj', 'mProp', 'mType'],
  data () {
    return {
      vCode: '',
      mVisible: false,
      mOptions: {
        value: '',
        mode: { name: 'javascript', json: true },
        theme: 'blackboard',
        lineNumbers: true,
        lineWrapping: true,
        extraKeys: { Ctrl: 'autocomplete' },
        lineWiseCopyCut: true,
        showCursorWhenSelecting: true,
        matchBrackets: true,
        line: true
      }
    }
  },
  computed: {
  },
  methods: {
    changes: function () {
    },
    mCancel: function () {
      this.mVisible = false
    },
    mConfirm: function () {
      const that = this
      that.$parent.$Any.updateObjProp(that.mObj, that.mProp, that.vCode)
      this.mVisible = false
    },
    openDlg: function () {
      this.vCode = this.mCode
    },
    showEditText: function () {
      this.mVisible = true
    }
  },
  mounted () {
    this.vCode = this.mCode
    if (this.mType) {
      this.mOptions.mode.name = this.mType
    }
  }
}
</script>

<style lang="less">
  .CodeMirror{
    overscroll-y: scroll !important;
    /*height: auto !important;*/
    height: 450px !important;
  }
</style>
